/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Rate info for buy or sell
 */
export interface SideInfo {
  /**
   * Clients free.
   */
  free: number;
  /**
   * Rate before commission. Usable to calculate live commission.
   */
  rate?: number;
  /**
   * Rate with commission(Uses for Price for client).
   */
  rateWithFee?: number;
  /**
   * Qty for client(in base asset).
   */
  units?: number;
  /**
   * Total for client(in quote asset).
   */
  total?: number;
}
